import { databases, DATABASE_ID, COLLECTION_ID_TEAM } from '../config/appwrite';
import { ID, Query } from 'appwrite';

/**
 * Team Service
 * Handles all database operations for Team Members
 * Collection Name: "Team SGM"
 * Collection ID: "TeamSGM" (Appwrite doesn't allow spaces in collection IDs)
 */

// Get all team members
export const getAllTeamMembers = async () => {
  try {
    const response = await databases.listDocuments(
      DATABASE_ID,
      COLLECTION_ID_TEAM,
      [
        Query.orderAsc('name'),
        Query.limit(1000)
      ]
    );
    return response.documents.map(formatTeamMember);
  } catch (error) {
    console.error('Error fetching team members:', error);
    throw error;
  }
};

// Get a single team member by ID
export const getTeamMemberById = async (id) => {
  try {
    const response = await databases.getDocument(
      DATABASE_ID,
      COLLECTION_ID_TEAM,
      id
    );
    return formatTeamMember(response);
  } catch (error) {
    console.error('Error fetching team member:', error);
    throw error;
  }
};

// Create a new team member
export const createTeamMember = async (memberData) => {
  try {
    const documentData = {
      name: memberData.name || '',
      lotName: memberData.lotName || '',
      position: memberData.position || '',
      contacts: memberData.contacts || '',
      email: memberData.email || ''
    };

    const response = await databases.createDocument(
      DATABASE_ID,
      COLLECTION_ID_TEAM,
      ID.unique(),
      documentData
    );
    return formatTeamMember(response);
  } catch (error) {
    console.error('Error creating team member:', error);
    throw error;
  }
};

// Update a team member
export const updateTeamMember = async (id, memberData) => {
  try {
    const documentData = {};
    
    if (memberData.name !== undefined) documentData.name = memberData.name;
    if (memberData.lotName !== undefined) documentData.lotName = memberData.lotName;
    if (memberData.position !== undefined) documentData.position = memberData.position;
    if (memberData.contacts !== undefined) documentData.contacts = memberData.contacts;
    if (memberData.email !== undefined) documentData.email = memberData.email;

    const response = await databases.updateDocument(
      DATABASE_ID,
      COLLECTION_ID_TEAM,
      id,
      documentData
    );
    return formatTeamMember(response);
  } catch (error) {
    console.error('Error updating team member:', error);
    throw error;
  }
};

// Delete a team member
export const deleteTeamMember = async (id) => {
  try {
    await databases.deleteDocument(
      DATABASE_ID,
      COLLECTION_ID_TEAM,
      id
    );
    return { success: true };
  } catch (error) {
    console.error('Error deleting team member:', error);
    throw error;
  }
};

// Format team member from Appwrite document format to app format
const formatTeamMember = (doc) => {
  return {
    id: doc.$id,
    name: doc.name || '',
    lotName: doc.lotName || '',
    position: doc.position || '',
    contacts: doc.contacts || '',
    email: doc.email || ''
  };
};
